import React from 'react';
import { RadialBar } from '@nivo/radial-bar';
import { RadialOverlay } from './RadialOverlay';

interface PropTypes {
  data: any;
  colors: string[];
}

const RadialChart: React.FC<PropTypes> = ({ data, colors }) => {
  return (
    <>
      <RadialOverlay />

      <div
        className={`
          absolute
          top-0
          bottom-0
          left-0
          right-0
          oveflow-hidden
          bg-center
          z-20
        `}
      >
        <RadialBar
          colors={colors}
          data={data}
          endAngle={360}
          innerRadius={0.45}
          padding={0.45}
          cornerRadius={19}
          margin={{ top: 8, right: 20, bottom: 8, left: 20 }}
          enableRadialGrid={false}
          enableCircularGrid={false}
          isInteractive={false}
          radialAxisStart={null}
          circularAxisOuter={null}
          labelsSkipAngle={3}
          labelsRadiusOffset={0.8}
          tracksColor="#EAEAEA"
          height={320}
          width={352}
          maxValue={100}
        />
      </div>
    </>
  );
};

export default RadialChart;
